"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Name = function Name(_ref) {
  var ticker = _ref.ticker,
    full = _ref.full;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, full ? _constants.TickerFullName[ticker] : _definitions.Ticker[ticker]);
};
exports.Name = Name;